// Mirrors the backend `buildAttachmentDisposition` in s3.service.ts. The presigned
// URL bakes Content-Disposition into the signature; if the API response omits
// `contentDisposition` (mixed-version deploys), reconstruct the exact same value
// here so the PUT can still match the signature.
const reconstructAttachmentDisposition = (filename: string): string =>
  `attachment; filename*=UTF-8''${encodeURIComponent(filename)}`;

export function buildSignedUploadHeaders({
  contentType,
  contentDisposition,
  filename,
  fallbackContentType,
}: {
  contentType?: string;
  contentDisposition?: string;
  filename: string;
  fallbackContentType: string;
}): Record<string, string> {
  return {
    'Content-Type': contentType ?? fallbackContentType,
    'Content-Disposition': contentDisposition ?? reconstructAttachmentDisposition(filename),
  };
}
